function renderBooleanFieldChangeHandlerTemplate({
  indent,
  defaultValueFromHandler
}: {
  indent: string
  defaultValueFromHandler: string
}): string {
  return `(checked) => {
${indent}            ${defaultValueFromHandler}(checked)
${indent}            formField.onChange(checked)
${indent}          }`
}

function renderBooleanFieldFormFieldTemplate({
  indent,
  fieldName,
  formItemProps,
  onCheckedChange,
  label,
  hintJsxContent
}: {
  indent: string
  fieldName: string
  formItemProps: string
  onCheckedChange: string
  label: string
  hintJsxContent: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      <FormControl>
${indent}        <Checkbox
${indent}          checked={formField.value}
${indent}          onCheckedChange={${onCheckedChange}}
${indent}          disabled={isPending}
${indent}        />
${indent}      </FormControl>
${indent}      <div className="flex flex-col gap-1">
${indent}        <FormLabel>${label}</FormLabel>${hintJsxContent}
${indent}      </div>
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}

export function renderBooleanFieldRenderer(
  request:
    | {
        kind: 'renderBooleanFieldChangeHandlerTemplate'
        props: {
          indent: string
          defaultValueFromHandler: string
        }
      }
    | {
        kind: 'renderBooleanFieldFormFieldTemplate'
        props: {
          indent: string
          fieldName: string
          formItemProps: string
          onCheckedChange: string
          label: string
          hintJsxContent: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderBooleanFieldChangeHandlerTemplate':
      return renderBooleanFieldChangeHandlerTemplate(request.props)
    case 'renderBooleanFieldFormFieldTemplate':
      return renderBooleanFieldFormFieldTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
